import { NgModule } from '@angular/core';
import { StoreTypeIconComponent } from '@gelato-api-ui/ui-kit/src/lib/store/store-type-icon/store-type-icon.component';
import { CommonModule } from '@angular/common';
import { StoreIconNamePipe } from '../pipes/store-icon-name.pipe';
import { StoreTypePipe } from '../pipes/store-type.pipe';
import { SdkPipesModule } from '@gelato-api-ui/sdk/src/lib/pipes/sdk-pipes.module';

const pipes = [StoreTypePipe, StoreIconNamePipe];

@NgModule({
  imports: [CommonModule, SdkPipesModule],
  exports: [StoreTypeIconComponent, ...pipes],
  declarations: [StoreTypeIconComponent, ...pipes],
})
export class StoreTypeIconModule {}
